export default __webpack_public_path__ + "static/media/analysis_video.2f648a0f.png";